export * from "./equality"
export function IsFunc(v: any): v is Function {
	return typeof v === "function"
}

export function IsString(v: any): v is string {
	return typeof v === "string"
}

export function IsInt(v: any): v is int {
	return IsNumber(v) && Number.isInteger(v)
}

export function IsNumber(v: any): v is int {
	return typeof v === "number"
}

export function IsNil(v: unknown): v is nil {
	return v === null || v === undefined
}

export function IsObject(v: any): v is Record<string, any> {
	return typeof v === "object" && !IsNil(v) && !Array.isArray(v)
}
